import React, { useState } from "react";
import s from "./casesList.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import { scaleOrdinal } from "d3-scale";
import Select from "react-select";

const CasesList = ({ data, title, note, source, practicePlaceholder, countryPlaceholder, value, casesData }) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();
  const practices = [...new Set(casesData.map((d) => d.Practice))];
  const options = practices.map((d) => ({ value: d, label: d }));

  const countries = [...new Set(casesData.map((d) => d.Country))].sort();
  const countryOptions = countries.map((d) => ({ value: d, label: d }));

  // Set initial filter value to "Restricting access to data", the first value in the data
  const [selectedPractice, setSelectedPractice] = useState(
    options.filter((d) => d.value == casesData[0].Practice)[0]
  );
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedData, setSelectedData] = useState(
    casesData.filter((d) => d.Practice == casesData[0].Practice)
  );

  const handleChange = (e) => {
    if (e) {
      setSelectedPractice(options.filter((d) => d.value == e.value)[0]);
      setSelectedData(casesData.filter((d) => d.Practice === e.value));
      setSelectedCountry("");
    } else {
      setSelectedPractice("");
      setSelectedData(casesData);
    }
  };

  const handleCountryChange = (e) => {
    if (e) {
      setSelectedCountry(
        countryOptions.filter((cntr) => cntr.value === e.value)
      );
      setSelectedData(casesData.filter((d) => d.Country === e.value));
      setSelectedPractice("");
    } else {
      setSelectedCountry("");
      setSelectedData(casesData);
    }
  };
  let practiceColorDomain = [...new Set(casesData.map((d) => d.Practice))];

  let practiceColorScale = scaleOrdinal()
    .range([
      "#DB4437",
      "#4267B2",
      "#2D8CFF",
      "#FF9900",
      "#444444",
      "#8BD1ED",
      "#7FBA00",
      "#6F2165",
      "#AAB8C2",
    ])
    .domain(practiceColorDomain);

  return (
    <>
      <div className={s.selectWrapper}>
        <Select
          options={options}
          value={selectedPractice}
          onChange={handleChange}
          className={s.select}
          placeholder={practicePlaceholder}
          isClearable={true}
        />
        <Select
          options={countryOptions}
          value={selectedCountry}
          onChange={handleCountryChange}
          className={s.select}
          placeholder={countryPlaceholder}
          isClearable={true}
        />
      </div>
      <Vizualisation
        title={title}
        note={note}
        source={source}
        ref={ref}
        size="xLarge"
      >
        <div className={s.gridContainer}>
          {selectedData.map((d) => {
            return d.Practice === d.Case ? (
              <div
                className={s.caseCard}
                style={{ backgroundColor: practiceColorScale(d.Practice) }}
              >
                <div className={s.practice}>{d.Case}</div>
                <div className={s.practiceExplanation}>{d.Conduct}</div>
              </div>
            ) : (
              <div className={s.caseCard}>
                <div
                  className={s.cardHeader}
                  style={{ backgroundColor: practiceColorScale(d.Practice) }}
                >
                  <div className={s.caseTitle}>{d.Case}</div>
                  <div className={s.caseCountry}>{d.Country}</div>
                </div>
                <div className={s.caseDescription}>{d.Conduct}</div>
              </div>
            );
          })}
        </div>
      </Vizualisation>
    </>
  );
};

export default CasesList;
